import * as Sentry from '@sentry/react';

import {
  darkActions,
  darkBackground,
  darkError,
  darkPrimary,
  darkSuccess,
  darkText,
  lightActions,
  lightBackground,
  lightError,
  lightPrimary,
  lightSuccess,
  lightText,
} from './colors';

Sentry.init({
  dsn: 'https://6a6a04dd640ba85fed4182daf9534d0e@sentry.signalos.tech/26',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        /^https:\/\/api\.visitors\.dev\.signalos\.app/,
        /^https:\/\/api\.visitors\.prod\.signalos\.app/,
        'https://test-admin.visitors.signalos.io',
        'https://admin.visitors.signalos.io',
      ],
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      showBranding: false,
      themeLight: {
        foreground: lightText.primary,
        background: lightBackground.paper,
        accentForeground: lightPrimary.contrast,
        accentBackground: lightPrimary.main,
        successColor: lightSuccess.main,
        errorColor: lightError.main,
        boxShadow: '0px 4px 24px 0px rgba(9, 30, 66, 0.12)',
        outline: `1px auto ${lightActions.focus}`,
      },
      themeDark: {
        foreground: darkText.primary,
        background: darkBackground.paper,
        accentForeground: darkPrimary.contrast,
        accentBackground: darkPrimary.main,
        successColor: darkSuccess.main,
        errorColor: darkError.main,
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.32)',
        outline: `1px auto ${darkActions.focus}`,
      },
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.visitors\.dev\.signalos\.app/,
    /^https:\/\/api\.visitors\.prod\.signalos\.app/,
    'https://test-admin.visitors.signalos.io',
    'https://admin.visitors.signalos.io',
  ],
  replaysSessionSampleRate: 0.3,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.PROD ? 'production' : 'development',
  enabled: import.meta.env.PROD,
});
